// src/routes/index.ts
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes";

function RootRouter() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default RootRouter;
